// @givmo/board — a date shown, not asked for, in the shape of the field that would ask for it.
//
// An approval seals the date a record carries, so the dialogs that approve or file a record show it:
// the record's own date, the minutes' meeting date, the date a consent bears. It renders in the date
// field's own label style so a dated record reads as the same field, filled — the approval dialog
// that asks for a missing date and the one that shows a present date differ only in whether the value
// can be typed. One component, so the four places that show a sealed date cannot drift apart.

import { testIdProp } from '@givmo/design-system';
import { displayDate } from '../lib/display';

export interface ReadOnlyDateProps {
  /** What the date is — "Date adopted", "Meeting date"… (`recordDateWording` in records-decode). */
  label: string;
  /** A `YYYY-MM-DD` calendar date. */
  date: string;
  testId?: string;
}

export function ReadOnlyDate({ label, date, testId }: ReadOnlyDateProps) {
  return (
    <div className="flex flex-col gap-8" {...testIdProp(testId)}>
      <span className="font-sans text-s12 font-w600 tracking-givmo text-black">{label}</span>
      <span className="font-sans text-s14 font-w400 tracking-givmo text-text-strong">
        {displayDate(date)}
      </span>
    </div>
  );
}
